// @ts-nocheck
/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Query:{
		getLastCompletedStep:{
			input:"GetLastCompletedStepInput"
		},
		getPronunciationGraderParameters:{
			input:"GetPronunciationGraderParametersInput"
		}
	},
	GetLastCompletedStepInput:{

	},
	GraderType: "enum" as const,
	AWSJSON: `scalar.AWSJSON` as const,
	GetPronunciationGraderParametersInput:{
		graderType:"GraderType"
	},
	Mutation:{
		completeStep:{
			input:"CompleteStepInput"
		},
		checkAnswer:{
			input:"CheckAnswerInput"
		},
		checkPronunciation:{
			input:"CheckPronunciationInput"
		},
		checkWriting:{
			input:"CheckWritingInput"
		},
		initializePronunciationGrader:{
			input:"InitializePronunciationGraderInput"
		},
		textToSpeech:{
			input:"TextToSpeechInput"
		},
		generateSpeech:{
			input:"GenerateSpeechInput"
		},
		textToCharacterSpeech:{
			input:"TextToCharacterSpeechInput"
		},
		generateCharacterSpeech:{
			input:"GenerateCharacterSpeechInput"
		},
		notifyTextToSpeechChunkReceived:{
			input:"TextToSpeechChunkInput"
		},
		createParentAccount:{
			input:"CreateParentAccountInput"
		},
		updateParentAccount:{
			input:"UpdateParentAccountInput"
		},
		createChildProfile:{
			input:"CreateChildProfileInput"
		},
		updateChildProfile:{
			input:"UpdateChildProfileInput"
		},
		registerDevice:{
			input:"RegisterDeviceInput"
		},
		unregisterDevice:{
			input:"UnregisterDeviceInput"
		},
		startSession:{
			input:"StartSessionInput"
		},
		generateUploadUrl:{
			input:"GenerateUploadUrlInput"
		}
	},
	CompleteStepInput:{

	},
	CheckAnswerInput:{

	},
	CheckPronunciationInput:{

	},
	CheckWritingEvaluation: "enum" as const,
	CheckWritingInput:{
		type:"CheckWritingType"
	},
	CheckWritingType: "enum" as const,
	GraderProvider: "enum" as const,
	InitializePronunciationGraderInput:{
		provider:"GraderProvider",
		metadata:"AWSJSON"
	},
	TextToSpeechInput:{

	},
	GenerateSpeechInput:{
		options:"GenerateSpeechOptions"
	},
	GenerateSpeechOptions:{

	},
	TextToCharacterSpeechInput:{

	},
	GenerateCharacterSpeechInput:{
		promptOptions:"PromptOptions"
	},
	PromptOptions:{
		promptType:"PromptType",
		metadata:"AWSJSON"
	},
	PromptType: "enum" as const,
	TextToSpeechChunkInput:{

	},
	CreateParentAccountInput:{

	},
	UpdateParentAccountInput:{

	},
	CreateChildProfileInput:{

	},
	UpdateChildProfileInput:{

	},
	RegisterDeviceInput:{

	},
	UnregisterDeviceInput:{

	},
	StartSessionInput:{

	},
	GenerateUploadUrlInput:{
		uploadType:"UploadType",
		metadata:"AWSJSON"
	},
	UploadType: "enum" as const,
	Subscription:{
		onTextToSpeechChunkReceived:{

		}
	},
	ID: `scalar.ID` as const
}

export const ReturnTypes: Record<string,any> = {
	defer:{

	},
	aws_cognito_user_pools:{
		cognito_groups:"String"
	},
	aws_oidc:{

	},
	aws_publish:{
		subscriptions:"String"
	},
	aws_iam:{

	},
	aws_subscribe:{
		mutations:"String"
	},
	aws_api_key:{

	},
	aws_lambda:{

	},
	aws_auth:{
		cognito_groups:"String"
	},
	Query:{
		getLastCompletedStep:"GetLastCompletedStepOutput",
		getPronunciationGraderParameters:"GetPronunciationGraderParametersOutput",
		me:"MeOutput",
		listChildProfiles:"ListChildProfilesOutput"
	},
	GetLastCompletedStepOutput:{
		lesson:"Int",
		task:"Int",
		step:"Int",
		completedAt:"String"
	},
	GetPronunciationGraderParametersOutput:{
		graderType:"GraderType",
		parameters:"AWSJSON"
	},
	AWSJSON: `scalar.AWSJSON` as const,
	MeOutput:{
		parent:"Parent"
	},
	Parent:{
		id:"ID",
		preferredName:"String",
		email:"String"
	},
	ListChildProfilesOutput:{
		childProfiles:"ChildProfile"
	},
	ChildProfile:{
		id:"ID",
		name:"String",
		age:"Int",
		incorrectHelpThreshold:"Int"
	},
	Mutation:{
		completeStep:"CompleteStepOutput",
		checkAnswer:"CheckAnswerOutput",
		checkPronunciation:"CheckPronunciationOutput",
		checkWriting:"CheckWritingOutput",
		initializePronunciationGrader:"InitializePronunciationGraderOutput",
		textToSpeech:"TextToSpeechOutput",
		generateSpeech:"GenerateSpeechOutput",
		textToCharacterSpeech:"SpeechOutput",
		generateCharacterSpeech:"SpeechOutput",
		notifyTextToSpeechChunkReceived:"TextToSpeechChunk",
		createParentAccount:"CreateParentAccountOutput",
		updateParentAccount:"UpdateParentAccountOutput",
		createChildProfile:"CreateChildProfileOutput",
		updateChildProfile:"UpdateChildProfileOutput",
		registerDevice:"RegisterDeviceOutput",
		unregisterDevice:"UnregisterDeviceOutput",
		startSession:"StartSessionOutput",
		deleteParentAccount:"DeleteParentAccountOutput",
		generateUploadUrl:"GenerateUploadUrlOutput"
	},
	CompleteStepOutput:{
		completedAt:"String"
	},
	CheckAnswerOutput:{
		isCorrect:"Boolean"
	},
	CheckPronunciationOutput:{
		overall:"Float",
		pronunciation:"Float",
		fluency:"Float",
		integrity:"Float",
		words:"Word",
		isCorrect:"Boolean"
	},
	Word:{
		word:"String",
		score:"Float",
		phoneScore:"Float"
	},
	CheckWritingOutput:{
		evaluation:"CheckWritingEvaluation",
		storageKey:"String"
	},
	InitializePronunciationGraderOutput:{
		provider:"GraderProvider",
		metadata:"AWSJSON"
	},
	TextToSpeechOutput:{
		id:"ID"
	},
	GenerateSpeechOutput:{
		id:"ID"
	},
	SpeechOutput:{
		id:"ID"
	},
	TextToSpeechChunk:{
		id:"ID",
		chunk:"String",
		order:"Int",
		isComplete:"Boolean"
	},
	CreateParentAccountOutput:{
		success:"Boolean"
	},
	UpdateParentAccountOutput:{
		success:"Boolean"
	},
	CreateChildProfileOutput:{
		success:"Boolean"
	},
	UpdateChildProfileOutput:{
		success:"Boolean"
	},
	RegisterDeviceOutput:{
		success:"Boolean"
	},
	UnregisterDeviceOutput:{
		success:"Boolean"
	},
	StartSessionOutput:{
		sessionNumber:"Int",
		sessionStartedAt:"String"
	},
	DeleteParentAccountOutput:{
		success:"Boolean"
	},
	GenerateUploadUrlOutput:{
		presignedUrl:"String",
		key:"String"
	},
	Subscription:{
		onTextToSpeechChunkReceived:"TextToSpeechChunk"
	},
	ID: `scalar.ID` as const
}

export const Ops = {
query: "Query" as const,
	mutation: "Mutation" as const,
	subscription: "Subscription" as const
}